<div class="progress">
  <div class="barOverflow">
    @if (complete) {
      <div>
        @for (sparkle of sparkleCount; track sparkle; let i = $index) {
          <img
            #sparkles
            [ngClass]="['sparkle', 'sparkle' + i]"
            src="assets/img/my-work/sparkle.svg"
            />
        }
      </div>
    }
    <div #bar class="bar">
      <div class="inner-circle"></div>
    </div>
    <div class="border"></div>
  </div>

  <div class="bar-label">{{ 'common.hours-minutes' | transloco: { hours: workedHours, minutes: workedMinutes } }}</div>
</div>
